const Meals = () => import("./views/Meals.vue");
const MealEdit = () => import("./views/MealEdit.vue");
const MealsToPrepare = () => import("./views/MealsToPrepare.vue");

const mealsRoute = "/meals";
const mealsToPrepareRoute = "/mealsToPrepare";

export default [
  {
    path: mealsRoute,
    name: "meals.list",
    component: Meals,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${mealsRoute}/create/meal/:mealId?`,
    name: "meals.create",
    component: MealEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${mealsRoute}/:mealId/edit`,
    name: "meals.edit",
    component: MealEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: mealsToPrepareRoute,
    name: "mealsToPrepare",
    component: MealsToPrepare,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
    },
  },
];
